export class ParametroDetalleArchivoDescargable {
    constructor() {
        this.CodigoEntidad = "";
        this.Periodo = "";
    }

    CodigoEntidad: string;
    Periodo: string;
}
export default ParametroDetalleArchivoDescargable;